import { BookingDTOTransportMode } from '@/clients/booking'

import { MilestonesStep } from '../domain/timelineTypes'
import { TransportMode } from '../domain/transportMode'
import { EventCode } from '../domain/transportPlanEvent'
import { TransportType } from '../domain/transportType'

type MilestoneEventMapLCL = {
  sea: EventCode
  air: EventCode
  rail?: EventCode
}

type MilestoneEventMapFCL = {
  sea: EventCode
  air?: never
  rail?: EventCode
}

type MilestoneEventMap = {
  lcl: MilestoneEventMapLCL
  fcl: MilestoneEventMapFCL
}

const deliveryEventsMap: MilestoneEventMap = {
  lcl: {
    sea: EventCode.SDC,
    air: EventCode.SDC,
    rail: EventCode.RAIL_DELIVERY,
  },
  fcl: {
    sea: EventCode.CDC,
    rail: EventCode.RAIL_DELIVERY,
  },
}

const cargoReadyEventsMap: MilestoneEventMap = {
  lcl: {
    sea: EventCode.CRD,
    air: EventCode.CRD,
    rail: EventCode.RAIL_CARGO_READY,
  },
  fcl: {
    sea: EventCode.CRD,
    rail: EventCode.RAIL_CARGO_READY,
  },
}

const pickupEventsMap: MilestoneEventMap = {
  lcl: {
    sea: EventCode.SPS,
    air: EventCode.SPS,
    rail: EventCode.RAIL_PICKUP,
  },
  fcl: {
    sea: EventCode.CAS,
    rail: EventCode.RAIL_PICKUP,
  },
}

const departureEventsMap: MilestoneEventMap = {
  lcl: {
    sea: EventCode.VDL,
    air: EventCode.ADO,
    rail: EventCode.RAIL_DEPARTURE,
  },
  fcl: {
    sea: EventCode.VDL,
    rail: EventCode.RAIL_DEPARTURE,
  },
}

const cgomoEventsMap: Partial<MilestoneEventMap> = {
  // LCL does not have CGOMO
  fcl: {
    sea: EventCode.CGOMO,
  },
}

const cgomdEventsMap: Partial<MilestoneEventMap> = {
  // LCL does not have CGOMD
  fcl: {
    sea: EventCode.CGOMD,
  },
}

const arrivalEventsMap: MilestoneEventMap = {
  lcl: {
    sea: EventCode.VAD,
    air: EventCode.AAD,
    rail: EventCode.RAIL_ARRIVAL,
  },
  fcl: {
    sea: EventCode.VAD,
    rail: EventCode.RAIL_ARRIVAL,
  },
}

const eventsMap: Partial<Record<MilestonesStep, Partial<MilestoneEventMap>>> = {
  cargoReady: cargoReadyEventsMap,
  pickup: pickupEventsMap,
  cgomo: cgomoEventsMap,
  departure: departureEventsMap,
  arrival: arrivalEventsMap,
  cgomd: cgomdEventsMap,
  delivery: deliveryEventsMap,
}

export const getMilestoneEventCode = (
  milestoneType: MilestonesStep,
  transportType: TransportType,
  transportMode: TransportMode | BookingDTOTransportMode
): EventCode | undefined => {
  if (transportMode === 'seaAir' || transportMode === 'road') {
    return undefined
  }
  return eventsMap[milestoneType]?.[transportType]?.[transportMode]
}
